export function bytesToMegabytes(bytes: number, fractionDigits: number = 0) {
	const megabytes = bytes / (1024 * 1024);
	return megabytes.toFixed(fractionDigits);
}
